import React, { FC, useState } from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { CSSTransition, TransitionGroup } from "react-transition-group";

import { UploadList } from "~/schemas/generated/graphql";
import { NOTIFICATIONS } from "~/constans/notifications";

import Button from "~/shared/ui/Fields/Button";

import Close from "~/components/Icons/Close";
import s from "./Notification.less";
import { usePermissions } from "~/shared/context/PermissionContext";

export type objNotofication = {
  id: string;
  type: string;
  textNotification: string;
  withConfirmation?: boolean;

  confirm?: (id: string | null, callback: () => void) => void;
  cancel?: (id: string | null) => void;
  logFile?: (id: string | null) => void;
  close?: (id: string | null) => void;
};

interface IProps {
  items?: objNotofication[];
  uploadList?: UploadList[];
}

const Notification: FC<IProps> = ({ items = [], uploadList = [] }) => {
  const { t } = useTranslation();
  const [isButt, setIsButt] = useState([]);
  const { hasPermission, loading: loadingPermissions } = usePermissions();
  const resetLoader = (itemId: string) => () =>
    setIsButt((prevState) => prevState.filter((el) => el !== itemId));

  return (
    <TransitionGroup style={{ width: "100%" }}>
      {items.map((item, i) => {
        const isError = item.type === NOTIFICATIONS.error;
        if (item) {
          return (
            <CSSTransition
              timeout={1500}
              key={item.id}
              style={{ width: "100%" }}
              classNames={{
                enter: s["animation-enter"],
                enterActive: s["animation-enter-active"],
                exit: s["animation-exit"],
                exitActive: s["animation-exit-active"],
              }}
            >
              <div
                className={clsx({
                  [s.notification]: true,
                  [s[item.type]]: true,
                })}
              >
                <div className={s.n_body}>
                  <span className={s.text_notification}>
                    {item.textNotification}
                  </span>
                  {item.close && (
                    <div
                      className={s.close}
                      onClick={() => item.close(item.id)}
                    >
                      <Close fill={"#485867"} width={"12"} height={"12"} />
                    </div>
                  )}

                  {item.withConfirmation && (
                    <div className={s.withConfirmation}>
                      {item.logFile && (
                        <Button
                          small
                          txtBtn={t("uploads.log_file")}
                          onClick={() => item.logFile(item.id)}
                          customClassName={s.log_file}
                        />
                      )}
                      {hasPermission("indicator.upload.accept") && (
                        <Button
                          small
                          txtBtn={t("ui.confirm")}
                          onClick={() => {
                            item.confirm(item.id, resetLoader(item.id));
                            setIsButt((prevState) => [...prevState, item.id]);
                          }}
                          customClassName={s.confirm}
                          loading={
                            isButt.filter((el) => item.id === el).length > 0
                          }
                          disabled={
                            isError ||
                            isButt.filter((el) => item.id === el).length > 0
                          }
                        />
                      )}
                      {hasPermission("indicator.upload.reject") && (
                        <Button
                          small
                          txtBtn={t("ui.cancel")}
                          onClick={() => item.cancel(item.id)}
                          customClassName={s.cancel}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </CSSTransition>
          );
        }
      })}
    </TransitionGroup>
  );
};

export default Notification;
